var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-overlay",class:{'active': _vm.store.busy}},[_c('div',{staticClass:"loading-wrapper"},[_c('div',{staticClass:"loading"}),_vm._v(" "),_c('span',{staticClass:"visually-hidden"},[_vm._v(_vm._s(_vm.$t('G.LIT_Loading')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }